<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Actualizar Password">
          <b-form>
            <b-form-group
              label="Usuario"
              label-for="nombre"
              :label-cols="2">
              <b-form-input 
                id="nombre"
                :value= "nombre" 
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Password"
              label-for="password"
              :label-cols="2">
              <b-form-input 
                id="password"
                v-model.trim= "$v.password.$model" 
                :state="passwordValido"
                type="password"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="passwordFeedback">
                {{ passwordInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Repita el Password"
              label-for="confirmedPassword"
              :label-cols="2">
              <b-form-input 
                id="confirmedPassword"
                v-model.trim= "$v.confirmedPassword.$model" 
                :state="confirmedPasswordValido"
                type="password"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="confirmedPasswordFeedback">
                {{ confirmedPasswordInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <div class="fixed-btn">
      <div class="abm-save-btn" 
          @click.prevent="save">
        <i class="fa fa-save fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" 
          @click.prevent="goInicio">
        <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-unlock-btn" 
          v-b-tooltip.hover title="Desbloquear"
          @click.prevent="desbloquear">
        <i class="fa fa-unlock-alt fa-2x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarioPWA/getField',
  mutationType: 'usuarioPWA/updateField',
});

export default {
  name: 'UsuarioPWA',
  components: {
    // appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      passwordValido: null,
      passwordInvalidoMsj: '',
      confirmedPasswordValido: null,
      confirmedPasswordInvalidoMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'nombre',
      'password',
      'confirmedPassword',
    ]),
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('usuarioPWA/getUsuario')
      // .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "password" || validarTodos) {
        if (this.$v.password.$error) {
          this.passwordValido = false;
          if (!this.$v.password.required) {
            this.passwordInvalidoMsj = 'Debe ingresar el password.';
          } else if (!this.$v.password.minLength || !this.$v.password.maxLength || !this.$v.password.strongPass) {
            this.passwordInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
          }
        } else {
          this.passwordValido = null;
          this.passwordInvalidoMsj = '';
        }
      }
      if (campo == "confirmedPassword" || validarTodos) {
        if (this.$v.confirmedPassword.$error) {
          this.confirmedPasswordValido = false;
          if (!this.$v.confirmedPassword.sameAs) {
            this.confirmedPasswordInvalidoMsj = 'El password no coincide con su confirmación.';
          }
        } else {
          this.confirmedPasswordValido = null;
          this.confirmedPasswordInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
          this.showSpinner();
          this.$store.dispatch('usuarioPWA/updatePassword')
            .then(()  => this.showModalMsj('La contraseña del usuario se actualizó con éxito.', this.goInicio, this.goInicio, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
      }
    },
    goInicio() {
      this.$router.push({ name: 'Dashboard' });
    },
    desbloquear () {
      this.showSpinner();
      this.$store.dispatch('usuarioPWA/desbloquear')
        .then(()  => this.showModalMsj('El usuario se desbloqueó con éxito.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      strongPass(pass) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(pass);
      } 

      /* "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$" */
    },
    confirmedPassword: {
      sameAs: sameAs('password')
    },
  },  
}
</script>

<style>
</style>
